import React, { useEffect, useState } from 'react';
import ApiService from "../../../Services/user/service";
import { Plus, Edit, Trash2 } from "lucide-react";
import Swal from 'sweetalert2';
import { toast } from 'react-toastify';
import { FaUniversity } from "react-icons/fa";
const Registeredbank = () => {
    const user_id = localStorage.getItem("user_id");
    const [bankDetails, setBankDetails] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [errors, setErrors] = useState({});
    const [editMode, setEditMode] = useState(false);
    const [editBankId, setEditBankId] = useState(null);

    const [formData, setFormData] = useState({
        bankName: "",
        accountHolderName: "",
        bankAccountNo: "",
        bankIfsc: "",
        upiId: "",
    });

    useEffect(() => {
        fetchbankdetails();
    }, []);

    const fetchbankdetails = async () => {
        try {
            const res = await ApiService.getUserBank({ userId: user_id });
            setBankDetails(res?.data?.data || []);
        } catch (error) {
            toast.error("Failed to load bank details");
        }
    };

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
        setErrors({ ...errors, [e.target.name]: "" });
    };

    // ✔ form validation
    const validateForm = () => {
        let newErrors = {};

        if (!/^[A-Za-z ]{3,50}$/.test(formData.bankName))
            newErrors.bankName = "Enter a valid bank name (letters only)";

        if (!/^[A-Za-z ]{3,50}$/.test(formData.accountHolderName))
            newErrors.accountHolderName = "Enter a valid account holder name";

        if (!/^[0-9]{9,18}$/.test(formData.bankAccountNo))
            newErrors.bankAccountNo = "Account number must be 9–18 digits";

        if (!formData.bankIfsc.trim() || !/^[A-Z]{4}0[A-Z0-9]{6}$/.test(formData.bankIfsc.toUpperCase()))
            newErrors.bankIfsc = "Invalid IFSC format";

        if (!formData.upiId.trim() || !/^[a-zA-Z0-9.\-_]{2,100}@[a-zA-Z]{2,64}$/.test(formData.upiId))
            newErrors.upiId = "Invalid UPI ID";

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    // ✔ Add or update bank
    const handleSubmit = async () => {
        if (!validateForm()) return;

        const result = await Swal.fire({
            title: editMode ? "Update Bank?" : "Add Bank?",
            text: editMode
                ? "Are you sure you want to update this bank detail?"
                : "Are you sure you want to add this bank detail?",
            icon: "question",
            showCancelButton: true,
            confirmButtonText: "Yes",
            customClass: {
                container: 'swal-low-zindex'
            }
        });

        if (!result.isConfirmed) return;

        try {
            const payload = {
                userId: user_id,
                ...formData,
            };

            let res;
            if (editMode) {
                payload.id = editBankId;
                res = await ApiService.updateBank(payload);

                if (res?.status) toast.success("Bank updated successfully");
            } else {
                res = await ApiService.addBank(payload);

                if (res?.status) toast.success("Bank added successfully");
            }

            if (res?.status) {
                fetchbankdetails();
                closeModal();
            } else {
                toast.error("Failed to save bank details");
            }
        } catch (error) {
            toast.error("Error while saving bank details");
        }
    };

    const closeModal = () => {
        setShowModal(false);
        setEditMode(false);
        setEditBankId(null);

        setFormData({
            bankName: "",
            accountHolderName: "",
            bankAccountNo: "",
            bankIfsc: "",
            upiId: ""
        });

        setErrors({});
    };

    // ✔ Delete bank
    const handleDelete = async (id) => {
        let confirm = await Swal.fire({
            title: "Delete Bank?",
            text: "Are you sure you want to delete this bank account?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Delete",
        });

        if (!confirm.isConfirmed) return;

        try {
            const res = await ApiService.deleteBank({ id });

            if (res?.status) {
                toast.success("Bank deleted successfully");
                fetchbankdetails();
            } else {
                toast.error("Delete failed");
            }
        } catch (error) {
            toast.error("Error deleting bank");
        }
    };

    // ✔ Edit bank
    const handleEdit = (item) => {
        setEditMode(true);
        setEditBankId(item._id);
        setFormData({
            bankName: item.bankName || "",
            accountHolderName: item.accountHolderName || "",
            bankAccountNo: item.bankAccountNo || "",
            bankIfsc: item.bankIfsc || "",
            upiId: item.upiId || "",
        });

        setShowModal(true);
    };


    const AddBankDetails = () => {
        setShowModal(true);
    };

    const handleSetPrimary = async (id) => {
        let confirm = await Swal.fire({
            title: "Set Primary Bank?",
            text: "This will make the bank your primary account.",
            icon: "question",
            showCancelButton: true,
            confirmButtonText: "Set Primary",
        });

        if (!confirm.isConfirmed) return;

        try {
            const res = await ApiService.setPrimaryBank({ id });

            if (res?.status) {
                toast.success("Primary bank updated");

                const updated = bankDetails.map((item) =>
                    item._id === id
                        ? { ...item, isPrimary: true }
                        : { ...item, isPrimary: false }
                );

                setBankDetails(updated);
            }
        } catch (error) {
            toast.error("Failed to set primary bank");
        }
    };


    return (
        <div className="container-fluid">
            <div className="card">
                <div className="card-header">
                    <div className="card-title d-flex justify-content-between w-100">
                        <div><FaUniversity size={28} /> Registered Bank</div>
                        <button className="btn btn-primary btn-sm d-flex align-items-center gap-1"
                            onClick={() => AddBankDetails()}

                        >
                            <Plus size={16} />
                            Add Bank Details
                        </button>

                    </div>
                </div>

                <div className="card-body ">

                    {bankDetails.length === 0 && (
                        <p>No Bank Accounts Found</p>
                    )}
                    {bankDetails.map((item) => (
                        <div
                            key={item._id}
                            className="p-3 mb-3 shadow-sm statement-card"
                            style={{
                                borderRadius: 12,
                                background: "#fff",
                                border: "1px solid #e5e5e5",
                            }}
                        >
                            <div className="row ">

                                {/* LEFT */}
                                <div className="col-md-4">
                                    <h5 className="mb-2 fw-semibold text-primary"> <b className="text-dark">Bank Name:</b> {item.bankName}</h5>

                                    <div className="small text-secondary mb-1">
                                        <b className="text-dark">Account Holder Name:</b> {item.accountHolderName}
                                    </div>

                                    <div className="small text-secondary mb-1">
                                        <b className="text-dark">Account Number:</b> {item.bankAccountNo}
                                    </div>
                                </div>

                                {/* CENTER */}
                                <div className="col-md-4 d-flex flex-column justify-content-center text-center">
                                    <div className="small mb-1">
                                        <b>IFSC:</b> {item.bankIfsc}
                                    </div>
                                    <div className="small mb-1">
                                        <b>UPI ID:</b> {item.upiId}
                                    </div>
                                </div>

                                {/* RIGHT */}
                                <div className="col-md-4">
                                    <div
                                        className="d-flex flex-column justify-content-between align-items-end"
                                        style={{ height: "100%" }}
                                    >
                                        {/* TOP */}
                                        <div>
                                            {item.isPrimary ? (
                                                <span className="badge bg-success">Primary</span>
                                            ) : (
                                                <button
                                                    className="btn btn-sm btn-outline-primary"
                                                    onClick={() => handleSetPrimary(item._id)}
                                                >
                                                    Set Primary
                                                </button>
                                            )}
                                        </div>

                                        {/* BOTTOM */}

                                        {item.isPrimary === false && (
                                            <div className='d-flex'>
                                                <button
                                                    onClick={() => handleEdit(item)}
                                                    className="btn btn-warning btn-sm me-2 d-flex align-items-center gap-1">
                                                    <Edit size={14} />
                                                    Edit
                                                </button>

                                                <button className="btn btn-danger btn-sm d-flex align-items-center gap-1"
                                                    onClick={() => handleDelete(item._id)}
                                                >
                                                    <Trash2 size={14} />
                                                    Delete
                                                </button>
                                            </div>
                                        )}
                                    </div>
                                </div>

                            </div>
                        </div>
                    ))}


                </div>
            </div>

            {/* ADD BANK DETAILS MODAL */}
            {showModal && (
                <div
                    className="modal fade show"
                    style={{
                        display: "block",
                        background: "rgba(0,0,0,0.5)",
                        backdropFilter: "blur(4px)"
                    }}
                >
                    <div className="modal-dialog modal-dialog-centered">
                        <div className="modal-content rounded-4 shadow">

                            {/* HEADER */}
                            <div className="modal-header">
                                <h5 className="modal-title">Add Bank Details</h5>
                                <button className="btn-close" onClick={closeModal}></button>

                            </div>

                            {/* BODY */}
                            <div className="modal-body">

                                <div className="mb-2">
                                    <label className="form-label">UPI ID</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        name="upiId"
                                        value={formData.upiId}
                                        onChange={handleChange}
                                        placeholder="Enter UPI ID"
                                    />
                                    {errors.upiId && <small className="text-danger">{errors.upiId}</small>}
                                </div>

                                <div className="mb-2">
                                    <label className="form-label">Bank Name</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        name="bankName"
                                        value={formData.bankName}
                                        onChange={(e) => {
                                            const value = e.target.value.replace(/[0-9]/g, ""); // remove numbers
                                            handleChange({ target: { name: "bankName", value } });
                                        }}
                                        placeholder="Enter bank name"
                                    />
                                    {errors.bankName && <small className="text-danger">{errors.bankName}</small>}
                                </div>

                                <div className="mb-2">
                                    <label className="form-label">Account Holder Name</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        name="accountHolderName"
                                        value={formData.accountHolderName}
                                        onChange={(e) => {
                                            const value = e.target.value.replace(/[0-9]/g, ""); // remove numbers
                                            handleChange({ target: { name: "accountHolderName", value } });
                                        }}
                                        placeholder="Enter holder name"
                                    />
                                    {errors.accountHolderName && <small className="text-danger">{errors.accountHolderName}</small>}
                                </div>

                                <div className="mb-2">
                                    <label className="form-label">Account Number</label>
                                    <input
                                        type="number"
                                        className="form-control"
                                        name="bankAccountNo"
                                        value={formData.bankAccountNo}
                                        onChange={(e) => {
                                            const val = e.target.value;

                                            // sirf numbers allow
                                            if (/^\d*$/.test(val)) {
                                                setFormData((prev) => ({ ...prev, bankAccountNo: val }));

                                                setErrors((prev) => ({
                                                    ...prev,
                                                    bankAccountNo: ""
                                                }));
                                            }
                                        }}
                                        placeholder="Enter account number"
                                    />
                                    {errors.bankAccountNo && <small className="text-danger">{errors.bankAccountNo}</small>}
                                </div>

                                <div className="mb-2">
                                    <label className="form-label">IFSC Code</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        name="bankIfsc"
                                        value={formData.bankIfsc}
                                        onChange={handleChange}
                                        placeholder="Enter IFSC code"
                                    />
                                    {errors.bankIfsc && <small className="text-danger">{errors.bankIfsc}</small>}
                                </div>



                            </div>

                            {/* FOOTER */}
                            <div className="modal-footer">
                                <button className="btn btn-secondary" onClick={closeModal}>
                                    Cancel
                                </button>


                                <button className="btn btn-primary"
                                    onClick={() => {
                                        handleSubmit();

                                    }}
                                >
                                    {editMode ? "Save Changes" : "Add Details"}
                                </button>

                            </div>

                        </div>
                    </div>
                </div>
            )}

        </div>

    )
}

export default Registeredbank